<script async setup>
import { defineProps } from "vue";

const props = defineProps({
  rating: {
    type: Number,
    required: true,
  },
});

const getStars = () => {
  return Array.from({ length: 5 }, (_, i) => i < Math.round(props.rating));
};
</script>

<template>
    <div class="flex gap-1 items-center">
        <kd-icon-star
            v-for="(filled, index) in getStars(rating)"
            :key="index"
            :filled="filled"
            v-bind="$attrs"
        />
    </div>
</template>
